import { render, staticRenderFns } from "./GiveAwayHelp.vue?vue&type=template&id=7d286bef&scoped=true&"
import script from "./GiveAwayHelp.vue?vue&type=script&lang=js&"
export * from "./GiveAwayHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d286bef",
  null
  
)

export default component.exports